<template>
  <div v-if="data != '' && data != null" class="text" >
    <div @click="handleClick" v-tooltip="'(future/ present/ past/ imperatve/)'">
      <span class="result-title">{{title}}:</span>
      <span
          v-bind:class="{ largerfont: largerFont }"
          v-html="this.highlightedText"
          v-if="!editing"
      ></span>
    </div>
    <div v-if="editing" >
      <textarea class="editing-text-area" v-bind:class="{ largerfont: largerFont }" v-model="editingText"></textarea>
      <button @click="handleSaveEdit" class="button" style="margin-top: 5px;">Save</button>
      <button @click="handleCancelEdit" class="button" style="margin-top: 5px;">Cancel</button>
    </div>
  </div>
</template>

<script>

  import { mapState } from 'vuex'
  import Utils from '../utils'

  export default {
  name: 'TenseResult',
  props: {
    data: [String, Number],
    title: String,
    columnName: String,
    largerFont: false
  },
    data() {
      return {
        editing: false,
        editingText: this.data,
        text: this.data
      }
    },
  computed: {
    ...mapState('app', [
      'searchText',
      'searchType',
      'allowEdits'
    ]),
    highlightedText() {
      const replaceNewlines = this.processNewLines(this.data);
      if (this.searchType === 'definiendumStarts' || this.searchType ==='definiendumLike' || this.searchType === 'definiendumRegex') {
        return replaceNewlines;
      }
      else {
        return Utils.highlight(replaceNewlines, this.searchText, "highlight", this.searchType);
      }
    }
  },
  methods: {
    handleClick() {
      if (this.allowEdits) {
        this.editing = true;
      }
    },
    async handleSaveEdit() {
      this.text = this.editingText;
      await this.saveEdit();
    },
    handleCancelEdit() {
      this.editing = false;
    },
    async saveEdit() {
      // eslint-disable-next-line no-console
      this.$log.debug(`Editing id=${this.entryId}, column = ${this.columnName} new value = "${this.text}"`)
      const newValue = this.text
      await this.$server.dictionaryService.patch(this.entryId, {
        value:newValue,
        columnName:this.columnName,
        comment:"",
        user: "",
        entryId: this.entryId,
        token: this.editToken
      });
      this.editing = false;
    },
    processNewLines(input) {
      // eslint-disable-next-line no-control-regex
      return input.replace(/\n|\\n/g, "<br/><span style='padding-right: 50pt'></span>").replace(/།་/g, "། " );
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .result-title {
    margin-right:5px;
    color: #7b7b7b;
  }

  .largerfont {
    font-size: 160%;
    line-height: 80%;
  }


  .editing-text-area {
    width: 100%;
  }

  .button {

    border: 0;
    outline: 0;
    cursor: pointer;
    color: rgb(60, 66, 87);
    background-color: transparent;
    box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 8px;
    display: inline-block;
    min-height: 28px;
    transition: background-color .24s,box-shadow .24s;
  }

  .add-note-button {
    border: 0;
    outline: 0;
    cursor: pointer;
    color: rgb(60, 66, 87);
    background-color: transparent;
    box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 8px;
    display: inline-block;
    min-height: 28px;
    transition: background-color .24s,box-shadow .24s;
  }

  button:hover {
    box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 3px 9px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
  }


</style>
